import { CustomFieldTypes } from "@/store/custom-fields/types";

export interface UserFacingCustomFieldType{
	customFieldTypeId: number,
	typeName: string
}

export const CustomFieldModalSortBy = {
	String: "string",
	Number: "number"
};

export const CustomFieldTypesForDisplay: UserFacingCustomFieldType[] = [
	{
		customFieldTypeId: CustomFieldTypes.Text,
		typeName: "Text"
	},
	{
		customFieldTypeId: CustomFieldTypes.TextArea,
		typeName: "Text Area"
	},
	{
		customFieldTypeId: CustomFieldTypes.Number,
		typeName: "Number"
	},
	{
		customFieldTypeId: CustomFieldTypes.Checkbox,
		typeName: "Checkbox"
	},
	{
		customFieldTypeId: CustomFieldTypes.Hyperlink,
		typeName: "Hyperlink"
	},
	{
		customFieldTypeId: CustomFieldTypes.Date,
		typeName: "Date"
	},
	{
		customFieldTypeId: CustomFieldTypes.Icon,
		typeName: "Icon"
	},
	{
		customFieldTypeId: CustomFieldTypes.List,
		typeName: "List"
	},
];
